import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "au-card au-stat" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-primary",
  role: "status"
}
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = { class: "au-stat-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["au-tile", `is-${_ctx.tone}`])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(['bi', _ctx.icon])
      }, null, 2)
    ], 2),
    _createElementVNode("div", null, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("common.loading")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["au-stat-value", { 'is-text': _ctx.isText }])
          }, _toDisplayString(_ctx.value), 3)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.label), 1)
    ])
  ]))
}